import React from 'react';
import Content from '../../partials/Content.jsx';
import {useLazyListPoliciesWithoutPaymentsQuery,} from "../../../features/apiSlice.js";
import {Col, Row, Table} from "react-bootstrap";
import DateRangeSelectionWidget from "../../widgets/Report/Selection/DateRangeSelectionWidget.jsx";
import Alert from "../../elements/ReactBootstrap/Alert.jsx";
import ErrorWidget from "../../widgets/ErrorWidget.jsx";
import Card from "../../elements/ReactBootstrap/Card.jsx";
import SmallSpinner from "../../elements/Spinner/SmallSpinner.jsx";
import DateShort from "../../elements/DateTime/DateShort.jsx";
import PremiumAmount from "../../elements/Values/PremiumAmount.jsx";
import PolicyInfoButton from "../../widgets/NavigationButtons/PolicyInfoButton.jsx";
import ExportToExcelButton from "../../elements/Buttons/ExportToExcelButton.jsx";
import {format} from "date-fns";

const WithoutPayments = () => {
    const [generate, {
        data: policies,
        error,
        isUninitialized,
        isLoading,
        isSuccess,
        isError,
    }] = useLazyListPoliciesWithoutPaymentsQuery();

    const dataForExport = isSuccess ? policies.map(policy => ({
        "Полица": policy.number,
        "Дата на сключване" : format(new Date(policy.issueDate), 'dd.MM.yyyy'),
        "Начална дата": format(new Date(policy.beginDate),'dd.MM.yyyy'),
        "Крайна дата" : format(new Date(policy.endDate), 'dd.MM.yyyy'),
        "ЗК" : policy.insuranceCompany.shortName,
        "Продукт" : policy.productName,
        "Лице за контакт" : policy.contactClient?.name,
        "Застраховащ" : policy.policyHolder?.name,
        "Застрахован" : policy.insuredClients?.[0]?.insuredClient?.name,
        "МПС" : policy.insuredVehicle?.plateNumber,
        "Марка" : policy.insuredVehicle?.brandName,
        "Модел" : policy.insuredVehicle?.modelName,
        "Бележка" : policy.note,
        "Сума" : policy.totalAmount,
        "Валута на полица" : policy.defaultCurrency,
        "Сума валута" : policy.totalAmountCurrency,
    "Консултант издател":  policy.issueUser?.shortName,
    "Офис издател": policy.issueOffice?.name ,
    })) : [];

    return (<Content title="Издадени полици без плащане по първа вноска">
        <Card outline baseClassName="card-warning">
            <Row className="row-cols-1 row-cols-sm-2 gy-3">
                <Col>
                    <DateRangeSelectionWidget onSubmit={values => generate({...values})} max={null}
                                              formName='policyWhithoutPaymentsFormDateRange'
                    />
                </Col>
            </Row>
        </Card>
        <Row>
            <Col>
                {isUninitialized && <Alert variant="secondary" heading="Моля, изберете период." />}
                {isError && <ErrorWidget error={error} />}
                {isLoading && <Card>
                    <SmallSpinner />
                </Card>
                }
                {isSuccess && <Card>
                    <ExportToExcelButton data={dataForExport} fileName={'policiesWithoutPayments'} />
                    <Table striped className="mb-0">
                    <thead>
                        <tr>
                            <th>Полица</th>
                            <th>Дата на издаване</th>
                            <th>Начална дата</th>
                            <th>Крайна дата</th>
                            <th>ЗК</th>
                            <th>Продукт</th>
                            <th>Лице за контакт</th>
                            <th>Застраховащ</th>
                            <th>Застрахован</th>
                            <th>МПС</th>
                            <th>Марка</th>
                            <th>Модел</th>
                            <th>Бележка</th>
                            <th>Сума</th>
                            <th>Консултант издател</th>
                            <th>Офис издател</th>
                        </tr>
                    </thead>
                    <tbody>
                    {policies.map(policy => {
                        return (<tr key={policy.id}>
                            <td><PolicyInfoButton policy={policy} /></td>
                            <td><DateShort date={policy.issueDate} /></td>
                            <td><DateShort date={policy.beginDate} /></td>
                            <td><DateShort date={policy.endDate} /></td>
                            <td>{policy.insuranceCompany.shortName}</td>
                            <td>{policy.productName}</td>
                            <td>{policy.contactClient?.name}</td>
                            <td>{policy.policyHolder?.name}</td>
                            <td>{policy.insuredClients?.[0]?.insuredClient?.name}</td>
                            <td>{policy.insuredVehicle?.plateNumber}</td>
                            <td>{policy.insuredVehicle?.brandName}</td>
                            <td>{policy.insuredVehicle?.modelName}</td>
                            <td>{policy.note}</td>
                            <td><PremiumAmount amount={policy.totalAmount} currency={policy.defaultCurrency}/></td>
                            <td>{policy.issueUser?.shortName}</td>
                            <td>{policy.issueOffice?.name}</td>
                        </tr>);
                    })}
                </tbody>
                </Table></Card>}
            </Col>
        </Row>
    </Content>);
};
export default WithoutPayments;
